import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

interface TranslationProgressBarProps {
  total: number;
  remaining: number;
  progress: number;
  totalLabel: string;
  remainingLabel: string;
}

const TranslationProgressBarSmall: React.FC<TranslationProgressBarProps> = ({
  total,
  remaining,
  progress,
  totalLabel,
  remainingLabel,
}) => {
  const getProgressGradient = (progress: number): string => {
    if (progress === 100) {
      return "linear-gradient(to right, #66bb6a, #43a047)"; // Green
    } else if (progress < 30) {
      return "linear-gradient(to right, #ff6b6b, #ff8a65)"; // Red
    } else {
      return "linear-gradient(to right, #ffa726, #ffb74d)"; // Orange
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        px: 1,
        py: 0.5,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="caption" color="text.secondary">
          {totalLabel}: {total}
        </Typography>
        <Typography variant="caption" color="warning.main">
          {remainingLabel}: {remaining}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 6,
          mt: 0.5,
          borderRadius: 5,
          backgroundColor: "#e0e0e0",
          "& .MuiLinearProgress-bar": {
            backgroundImage: getProgressGradient(progress),
          },
        }}
      />
    </Box>
  );
};

export default TranslationProgressBarSmall;
